export const compareHash = (hashA: string | null | undefined, hashB: string | null | undefined) => {
  if (!hashB) return null;
  if (hashA === undefined) return null;

  return hashB === hashA;
};
